import { FC } from "react";
import { Box, Fade, Grid, Stack, Typography } from "@mui/material";

interface Props {
  currentIndex: number;
  setImgContanerRef: (ref: HTMLDivElement) => void;
  imgContanerRef: HTMLDivElement | null;
  isMobile: boolean;
  steps: { label: string; image: string }[];
}

export const SingleItem: FC<Props> = ({
  isMobile,
  imgContanerRef,
  setImgContanerRef,
  currentIndex,
  steps,
}) => {
  return (
    <Box
      component="section"
      sx={{
        mt: isMobile ? 5 : 15,
        mb: 15,
      }}
    >
      <Grid
        direction={isMobile ? "column" : "row"}
        container
        spacing={2}
        sx={{
          mt: isMobile ? 4 : 5,
        }}
      >
        <Grid item xs={isMobile ? 12 : 5}>
          <Stack
            justifyContent="space-between"
            alignItems="center"
            spacing={isMobile ? 8 : 5}
          >
            {steps.map((el, idx) => (
              <Typography
                key={idx}
                variant={isMobile ? "h6" : "h4"}
                fontWeight={isMobile ? 500 : 600}
                fontSize={isMobile ? "2rem" : "3rem"}
                id="step-title"
                pl={isMobile ? 0 : 15}
                sx={{
                  fontSize: "23px",
                  fontWeight: "500",
                  color: "#0B1370",
                  lineHeight: "32px",
                  ...(isMobile && {
                    display: "flex",
                    flexDirection: "column-reverse",
                    alignItems: "center",
                    justifyContent: "center",
                    textAlign: "center",
                    gap: 2,
                  }),
                  py: `${(imgContanerRef?.offsetHeight ?? 0) / 2}px`,
                }}
              >
                {el.label}
                {isMobile && (
                  <Box
                    component="img"
                    src={el.image}
                    sx={{
                      width: "100%",
                    }}
                  />
                )}
              </Typography>
            ))}
          </Stack>
        </Grid>
        {!isMobile && (
          <Grid item xs={7}>
            <Box
              component="div"
              ref={setImgContanerRef}
              sx={{
                p: 1,
                borderRadius: "12px",
                position: "sticky",
                top: "20vh",
                width: "fit-content",
                height: "60vh",
              }}
            >
              {steps.map((_el, idxx) => (
                <Fade in={currentIndex === idxx} timeout={700} key={idxx}>
                  <Box
                    component="img"
                    loading="lazy"
                    src={steps[currentIndex].image}
                    alt={steps[currentIndex].label}
                    sx={{
                      height: "100%",
                      width: "100%",
                      maxWidth: "100%",
                      objectFit: "cover",
                      display: currentIndex === idxx ? "block" : "none",
                    }}
                  />
                </Fade>
              ))}
            </Box>
          </Grid>
        )}
      </Grid>
    </Box>
  );
};
